<template>
  <div class="summaryContainer">
    <div class="main-container">
      <h2> Inside Plan </h2>
      <div class="detailsContainer">
        <div class="detailsItem">
          <p class="ml-2">{{ this.$tc('TechnicalLocal', 1) }}</p>
          <treeselect
            v-model="techLocalUuid"
            :options="techLocalOptions"
            class="techLocalSelect"
            :disable-branch-nodes="true"
            :show-count="true"
            disableFuzzyMatching
          />
        </div>
        <div class="detailsItem">
          <p class="ml-2">Phase</p>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <p v-on="on" class="itemInput">{{ phase ? getPhaseName(phase): ''}}</p>
            </template>
            <span>{{ phase ? getPhaseName(phase): '' }}</span>
          </v-tooltip>
        </div>
        <div class="detailsItem">
          <p class="ml-2">Network Label</p>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <p v-on="on" class="itemInput">{{ networkLevel ? getNetworkLabel(networkLevel) : '' }}</p>
            </template>
            <span>{{ networkLevel ? getNetworkLabel(networkLevel) : '' }}</span>
          </v-tooltip>
        </div>
        <div class="detailsItem">
          <p>Cables</p>
          <v-switch style="padding: 2px 0 0 3px;" v-model="switchBtn" inset :color="'accent'" hide-details/>
        </div>
      </div>
      <cables-table :origin="cablesIn" :destination="cablesOut" v-if="switchBtn"/>
    </div>
  </div>
</template>

<script>
  import { workspaceTechSitesLocalsMixin } from "@/mixins/workspaceTechSitesLocalsMixin";
  import CablesTable from './CablesTable.vue';
  export default {
    name: "TechnicalLocalSummary",
    components: {
      CablesTable
    },
    props: {
      phase: {
        type: String
      },
      networkLevel: {
        type: String
      },
      cablesIn : {
        type: Array
      },
      cablesOut : {
        type: Array
      }
    },
    mixins: [workspaceTechSitesLocalsMixin],
    data() {
      return {
        switchBtn: false,
        techLocalOptions: [],
        techLocalUuid: null,
        refreshIsDisabled: false,
      };
    },
    mounted(){
        this.getOptions();
    },
    computed: {

    },
    watch:{
      techLocalUuid(value){
        this.$emit('set-tech-uuid', value);
      }
    },
    methods: {
      getOptions() {
        const workspaceUuid = this.$store.getters.workspace.uuid;
        this.GET_WORKSPACE_TECHNICAL_SITES_WITH_LOCALS(workspaceUuid).then(
          technicalSitesWithLocals => {
            this.techLocalOptions = this.getTechnicalSitesWithLocalsOptions(
              technicalSitesWithLocals
            );
          }
        );
      },
      getPhaseName(phaseCode){
        const projectPhases = this.$store.getters.optionLists_phase;
        const phase = projectPhases.find(phase => phase.code === phaseCode);
        return phase.client_label ? phase.client_label : phase.libelle;
      },
      getNetworkLabel(networkLevel){
        const networkLevels = this.$store.getters.optionLists_cableType;
        const networkObj = networkLevels.find( item => item.code === networkLevel);
        return networkObj.libelle;
      }
    }
  }
</script>

<style>
  .summaryContainer{
    display: flex;
    flex-direction: row;
    background-color: #eae7e7;
    width: 100%;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 20px 20px 20px 35px;
  }
  .summaryContainer h2{
    text-align: start;
    margin-bottom: 20px;
    color: #4fa2b7;
  }
  .detailsContainer{
    width: 100%;
    display: flex;
    gap: 25px;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .detailsItem{
    flex: 1;
    max-width: 140px;
  }
  .detailsItem > p {
    margin: 0 !important;
    text-align: start;
  }
  .itemInput{
    padding: 6px 4px 6px 9px;
    background-color: white;
    border-radius: 10px;
    width: 100%;
    height: 30px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    font-size: 12px;
  }
  .techLocalSelect{
    height: 29px;
    font-size: 11px;
  }
  .techLocalSelect .vue-treeselect__control {
    border-radius: 10px !important;
  }

  .buttons-container {
    width: 50px;
  }

  .main-container {
    width: 100%;
  }

  .reloadBtn{
    min-width: 30px !important;
    height: 30px !important;
    padding: 0 !important;
    margin-left: 20px;
    margin-bottom: 10px;
    background-color: #4fa2b7 !important;
  }

  .spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
  }
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/TechnicalLocalSummary.vue